import { createAction } from '@reduxjs/toolkit';

export const digitalUpdateRequest = createAction('emailsDigital/updateRequest');
export const digitalUpdateError = createAction('emailsDigital/updateError');
export const digitalUpdateStore = createAction('emailsDigital/updateStore');

export const digitalStore = createAction('emailsDigital/store');
export const digitalClear = createAction('emailsDigital/clear');

export const digitalUpdateId = createAction('emailsDigital/updateId');
export const digitalUpdateIsDisplayPrice = createAction('emailsDigital/updateIsDisplayPrice');
export const digitalUpdateLayout = createAction('emailsDigital/updateLayout');
export const digitalUpdateItems = createAction('emailsDigital/updateItems');

export const digitalAddItemRequest = createAction('emailsDigital/addItemRequest');
export const digitalUpdateItemRequest = createAction('emailsDigital/updateItemRequest');
export const digitalDeleteItemRequest = createAction('emailsDigital/deleteItemRequest');
